<template>
  <div class="tw:mx-4 tw:lg:mx-0">
    <div class="tw:my-4">
      <ManageUserRoles />
    </div>
  </div>
</template>

<script setup lang="ts">
import ManageUserRoles from '@/components/settings/teamSettings/ManageUserRoles.vue'
</script>
